import { useState } from "react"
import toast from "react-hot-toast"
import { Button, Textarea } from "@aix/ui"

import { trpc } from "../../lib/trpc"

interface RunResponse {
  run?: {
    id?: number
  }
}

export function AgentChatPanel({
  initialAgentId,
  onOpenRun,
}: {
  initialAgentId: number
  onOpenRun: (runId: number) => void
}) {
  const [prompt, setPrompt] = useState("")
  const utils = trpc.useUtils()
  const runMutation = trpc.brainAgents.run.useMutation({
    onSuccess: async (result: RunResponse) => {
      toast.success("Run queued")
      setPrompt("")
      await utils.brainAgents.get.invalidate({ id: initialAgentId })
      if (typeof result.run?.id === "number") onOpenRun(result.run.id)
    },
    onError: (error) => toast.error(error.message || "Run failed"),
  })

  const submit = () => {
    const trimmed = prompt.trim()
    if (!trimmed) {
      toast.error("Prompt is required")
      return
    }
    runMutation.mutate({ id: initialAgentId, prompt: trimmed })
  }

  return (
    <div className="space-y-3">
      <div className="border border-border bg-secondary/40 p-3">
        <div className="text-sm font-semibold text-foreground">Run prompt</div>
        <div className="mt-1 text-sm text-muted-foreground">
          Queue a real brain-server run for this agent and inspect the resulting output in the run drawer.
        </div>
      </div>
      <Textarea
        value={prompt}
        onChange={(event) => setPrompt(event.target.value)}
        placeholder="Ask this agent to investigate, test, or report..."
        className="min-h-[180px]"
      />
      <div className="flex justify-end">
        <Button onClick={submit} loading={runMutation.isLoading}>
          Queue run
        </Button>
      </div>
    </div>
  )
}
